import { useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { match } from 'ts-pattern';
import { useRouterEvents } from '../../../../hooks/useRouterEvents';
import { TermsJson } from '../../../../types/AccountsTypes';
import { AsideWithLayout } from '../../../layouts';
import { AsideWithLayoutMenusProp } from '../../../layouts/AsideWithLayout/AsideWithLayout';
import { PrivacyTerms } from './components/PrivacyTerms';
type TermMenuType = 'normal' | 'edu' | 'wallet';
const validateType = (queryString: string): TermMenuType => {
  return (['normal', 'edu', 'wallet'] as TermMenuType[]).find(d => d === queryString) || 'normal';
};
export const Terms = ({
  data
}: {
  data: Record<string, any>;
}) => {
  const router = useRouter();
  const locale = router.locale ?? 'ko';
  const {
    t
  } = useTranslation(['accounts']);
  const [termsType, setTermsType] = useState<TermMenuType>(validateType(String(router.query.type)));
  const [termsItems] = useState<TermsJson>({
    termsNormal: data?.termsNormal,
    termsEdu: data?.termsEdu,
    termsWallet: data?.termsWallet
  });
  const handleButtonClick = (type: TermMenuType) => {
    router.push({
      pathname: router.pathname,
      query: {
        type: type
      }
    }, undefined, {
      shallow: true
    }).then(() => {
      setTermsType(type); // routeChangeComplete 이벤트가 먹히는 이슈가 있어서 추가적으로 셋팅 실행
    });
  };
  useRouterEvents('routeChangeComplete', () => {
    /** 쿼리스트링 변경 시에 보여줄 내용 변경 처리(뒤로 가기, 앞으로 가기 대응) */
    setTermsType(validateType(String(router.query.type)));
  });
  const menuItems = (): AsideWithLayoutMenusProp => {
    const allButton = [{
      id: 'normal',
      isActive: termsType === 'normal',
      render: <div style={{
        width: '100%'
      }} onClick={() => handleButtonClick('normal')}>
            {t('accounts:termsPage.menu.zep')}
          </div>
    }, {
      id: 'edu',
      isActive: termsType === 'edu',
      render: <div style={{
        width: '100%'
      }} onClick={() => handleButtonClick('edu')}>
            {t('accounts:termsPage.menu.zepEdu')}
          </div>
    }, {
      id: 'wallet',
      isActive: termsType === 'wallet',
      render: <div style={{
        width: '100%'
      }} onClick={() => handleButtonClick('wallet')}>
            {t('accounts:termsPage.menu.zetaWallet')}
          </div>
    }];
    if (locale === 'ja') {
      // 일본어일경우 normal 버튼
      return allButton.filter(({
        id
      }) => id === 'normal' || id === 'wallet');
    }
    if (locale === 'en') {
      // 영어는 edu 제외
      return allButton.filter(({
        id
      }) => id !== 'edu');
    }
    return allButton;
  };
  return <AsideWithLayout.Wrapper data-sentry-element="unknown" data-sentry-component="Terms" data-sentry-source-file="Terms.tsx">
      <AsideWithLayout.Container data-sentry-element="unknown" data-sentry-source-file="Terms.tsx">
        <AsideWithLayout.SideButtons menuItems={menuItems()} data-sentry-element="unknown" data-sentry-source-file="Terms.tsx" />
        <AsideWithLayout.Content data-sentry-element="unknown" data-sentry-source-file="Terms.tsx">
          {match(termsType).with('normal', () => <PrivacyTerms.Section data={termsItems.termsNormal} />).with('edu', () => <PrivacyTerms.Section data={termsItems.termsEdu || ''} />).with('wallet', () => <PrivacyTerms.Section data={termsItems.termsWallet} />).exhaustive()}
        </AsideWithLayout.Content>
      </AsideWithLayout.Container>
    </AsideWithLayout.Wrapper>;
};